import React from 'react';
import './PrimaryHeader.css';

function PrimaryHeader() {
    const address = "226 N Main St, Centerton, AR 72719";
    const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent("Desi Bites, " + address)}`;
    const phoneNumber = "+14794129916";

    return (
        <header className="top-bar">
            <div className="top-bar__inner">
                {/* Left — Brand */}
                <a href="/" className="top-bar__brand">
                    <span className="top-bar__brand-accent">Desi</span>
                    <span className="top-bar__brand-text">Bites</span>
                </a>

                {/* Center — Info pills */}
                <div className="top-bar__info">
                    <a className="top-bar__pill" href={mapUrl} target="_blank" rel="noopener noreferrer">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
                        <span className="top-bar__pill-text">{address}</span>
                    </a>
                    <a className="top-bar__pill" href={`tel:${phoneNumber}`}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
                        <span className="top-bar__pill-text">(479) 412-9916</span>
                    </a>
                    <button
                        className="top-bar__pill"
                        onClick={() => {
                            const footer = document.querySelector('.footerBody .hours');
                            if (footer) footer.scrollIntoView({ behavior: 'smooth' });
                        }}
                    >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                        <span className="top-bar__pill-text">Hours</span>
                    </button>
                </div>

                {/* Right — Social icons */}
                <div className="top-bar__social">
                    <a href="https://www.instagram.com/desibitesnwa?igsh=MWdyYTFmNDV6d2V3ZA==" target="_blank" rel="noopener noreferrer" className="top-bar__social-link" aria-label="Instagram">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
                    </a>
                    <a href="https://m.facebook.com/desibitesnwa/" target="_blank" rel="noopener noreferrer" className="top-bar__social-link" aria-label="Facebook">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>
                    </a>
                    <a href="https://www.doordash.com/store/desi-bites-centerton-31061357" target="_blank" rel="noopener noreferrer" className="top-bar__social-link" aria-label="DoorDash">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 17H4a2 2 0 01-2-2V5a2 2 0 012-2h16a2 2 0 012 2v10a2 2 0 01-2 2h-1"/><polygon points="12 15 17 21 7 21 12 15"/></svg>
                    </a>
                </div>
            </div>
        </header>
    )
}

export default PrimaryHeader;
